import { Button, Icon, Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export default function DeactivateConfirmModal({
  isOpen,
  onConfirm = () => null,
  onCancel = () => null,
  isLoading = false,
}: Props) {
  const { t } = useTranslation(
    TranslationsKeys.TEACHER_MANAGMENT_TEACHER_ACTIVATION,
  );
  const prefix = 'deactivateConfirmation';

  return (
    <Modal isOpen={isOpen} toggle={() => null}>
      <div className="d-flex flex-column align-items-center">
        <Icon name="warning" size={40} />
        <h1 className="text-dark fs-20 mb-0 mt-5 text-center">
          {t(`${prefix}.title`)}
        </h1>
        <p className="fs-16 my-5 mb-3 lh-30 text-center">
          {t(`${prefix}.description`)}
        </p>

        <div className="d-flex w-100 flex-wrap" style={{ gap: 22 }}>
          <Button
            text={t(`common:actions.cancel`)}
            outlined
            size="lg"
            onClick={onCancel}
            className="flex-grow-1"
            style={{ width: 191 }}
            disabled={isLoading}
          />
          <Button
            text={t(`common:actions.confirm`)}
            size="lg"
            onClick={onConfirm}
            className="flex-grow-1"
            style={{ width: 191 }}
            loading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}
